export const categories = [
  {
    id: 'premium-gift',
    name: '精品水蜜桃礼盒',
    slug: 'premium-gift',
    description: '精选大果礼盒装，送礼体面大方，每颗桃子都经过严格筛选',
    icon: 'ri-gift-line',
  },
  {
    id: 'fresh-pick',
    name: '鲜摘蜜桃',
    slug: 'fresh-pick',
    description: '清晨采摘当日发货，保证最佳新鲜度与口感',
    icon: 'ri-leaf-line',
  },
  {
    id: 'fruit-basket',
    name: '桃子礼篮',
    slug: 'fruit-basket',
    description: '精选多品种搭配，丰富口感层次，满足全家需求',
    icon: 'ri-shopping-basket-line',
  },
  {
    id: 'seasonal',
    name: '时令限定',
    slug: 'seasonal',
    description: '当季稀有品种，数量有限，品味一年中最独特的甜蜜',
    icon: 'ri-calendar-check-line',
  },
];

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
}